import { useParams } from "react-router-dom";
import database from "../data/database.json";
import HeaderUser from "../layouts/HeaderUsers";
import ContentUsers from "../layouts/ContentUsers";
import { UseScrollToTop } from "../helpers";

const Users = () => {
  UseScrollToTop();
  const { id } = useParams();

  const dataUser = database.users.find((user) => user.id === id);

  return (
    <div className="content-wrapper">
      <HeaderUser dataUser={dataUser}></HeaderUser>
      <ContentUsers dataUser={dataUser}></ContentUsers>
    </div>
  );
};

export default Users;
